import { NotificationModuleType } from './notification-module-type';

export class NotificationRuleBaseDto {
  name: string;
  type: NotificationModuleType;
}
